<template>
  <div>
    <v-breadcrumbs :items="items"></v-breadcrumbs>

    <v-card-title>
      Invoices
      <v-spacer></v-spacer>

      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-row>
        <v-col cols="12" sm="6" md="3">
          <v-menu
              v-model="menu2"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                  v-model="date"
                  label="Select Date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  hide-details
                  outlined
                  dense
              ></v-text-field>
            </template>
            <v-date-picker
                v-model="date"
                @input="menu2 = false"
                @click:date="dateSelect"
                :max="nowDate"
            ></v-date-picker>
          </v-menu>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
              outlined
              dense
          ></v-text-field>
        </v-col>
        <v-col cols="1" class="me-5">
          <v-btn depressed color="primary" append-icon="mdi-printer" v-on:click="printList"
          ><v-icon>mdi-printer </v-icon> Self</v-btn
          >
        </v-col>
        <v-col cols="1" class="ms-5">
          <v-btn
              depressed
              color="primary"
              append-icon="mdi-printer"
              v-on:click="printListAll"
          ><v-icon>mdi-printer </v-icon> All User
          </v-btn>
        </v-col>
      </v-row>
    </v-card-title>
    <v-data-table
        :headers="headers"
        :items="itemsWithSno"
        class="elevation-1"
        :search="search"
        dense
        mobile-breakpoint="0"
        :loading="loadingstatus"
        loading-text="Loading... Please wait"
    >
      <template v-slot:item.status="{ item }">
        <v-chip :color="getColor(item.status)" dark>
          {{ item.status.toUpperCase() }}
        </v-chip>
      </template>
      <template v-slot:item.actions="{ item }">
        <!-- <v-tooltip top v-if="item.invoice_type == 'consultation'">
          <template v-slot:activator="{ on, attrs }">
            <v-chip
              @click="internal_refer(item)"
              dark
              v-bind="attrs"
              v-on="on"
              class="ma-2"
              open
              prepend-icon="mdi-printer"
              color="primary"
              label
              outlined
              small
            >
              <v-icon> IR </v-icon>
            </v-chip>
          </template>
          <span>Internal Refer</span>
        </v-tooltip> -->
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-chip
                @click="invoice_print(item)"
                dark
                v-bind="attrs"
                v-on="on"
                class="ma-2"
                open
                prepend-icon="mdi-printer"
                color="primary"
                label
                outlined
                small
            >
              <v-icon> mdi-printer </v-icon>
            </v-chip>
          </template>
          <span>Invoice Print</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }" v-if="item.inv_date == nowDate">
            <v-chip
                @click="invoice_edit(item)"
                dark
                v-bind="attrs"
                v-on="on"
                color="primary"
                label
                outlined
                small
            >
              <v-icon> mdi-pencil </v-icon>
            </v-chip>
          </template>
          <span>Invoice Edit</span>
        </v-tooltip>
        <!-- <v-tooltip top>
          <template v-slot:activator="{ on, attrs }" v-if="item.inv_date == nowDate">
            <v-chip
              @click="void_request(item)"
              dark
              v-bind="attrs"
              v-on="on"
              class="ma-2"
              open
              prepend-icon="mdi-printer"
              color="warning"
              label
              outlined
              small
            >
              <v-icon> mdi-alert-circle-outline </v-icon>
            </v-chip>
          </template>
          <span>Void Request</span>
        </v-tooltip> -->
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
    </v-data-table>
    <template>
      <div class="text-center">
        <v-dialog v-model="dialog" width="500">
          <v-card>
            <v-card-title class="text-h5 grey lighten-2">
              Internal Referral
            </v-card-title>
            <v-row>
              <v-col cols="6">
                <v-card-text v-if="internal_doctor" class="my-4 text-subtitle-1">
                  <strong> Patient Info </strong><br />
                  {{ internal_doctor.patient.patient_id }}<br />
                  {{ internal_doctor.patient.patient_name }}<br />
                  {{ internal_doctor.patient.patient_phone }}
                </v-card-text>
              </v-col>
              <v-col cols="6">
                <v-card-text v-if="internal_doctor" class=""
                ><strong> Invoice Info </strong><br />{{ internal_doctor.invoice_id
                  }}<br />{{ internal_doctor.invoice_type }}</v-card-text
                >
              </v-col>
              <v-col cols="6">
                <v-card-text v-if="internal_doctor" class="my-4 text-subtitle-1"
                ><strong> Doctor Info </strong><br />
                  {{ internal_doctor.doctor.dr_id }}
                  <br />
                  {{ internal_doctor.doctor.dr_name }}
                </v-card-text>
              </v-col>

              <v-col cols="6">
                <v-card-title>
                  Internal Referral to
                  <v-spacer></v-spacer>
                </v-card-title>
                <v-autocomplete
                    dense
                    v-model="internal_doctor_to"
                    :items="doctors"
                    title="select Doctor"
                    single-line
                    item-text="dr_name"
                    item-value="id"
                    return-object
                    outlined
                ></v-autocomplete>
                <v-simple-table dense>
                  <template>
                    <tbody>
                    <tr>
                      <td>Referral Doctor</td>
                      <td>

                      </td>
                    </tr>
                    <tr>
                      <td>Doctor ID</td>
                      <td>
                          <span v-if="internal_doctor_to">
                            {{ internal_doctor_to.dr_id }}</span
                          >
                      </td>
                    </tr>
                    <tr>
                      <td>Doctor Name</td>
                      <td>
                          <span v-if="internal_doctor_to">
                            {{ internal_doctor_to.dr_name }}</span
                          >
                      </td>
                    </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
            </v-row>
            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="dialog = false"> I accept </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </template>
  </div>
</template>

<style scoped>
.layout {
  display: inline-block;
  width: 100%;
}
</style>
<script>
import atshq from "../../../js/setup";
export default {
  data() {
    return {
      dialog: false,
      date: new Date().toISOString().substr(0, 10),
      nowDate: new Date().toISOString().substr(0, 10),
      menu2: false,
      loadingstatus: true,
      returnUrl: atshq.defaults.headers.common.app_URL,
      search: "",
      doctors: "",
      internal_doctor: "",
      internal_doctor_to: "",
      headers: [
        {
          text: "Serial #",
          value: "sno",
        },
        { text: "Invoice ID", value: "invoice_id" },
        {
          text: "Invoice Type",
          value: "invoice_type",
        },
        {
          text: "Patient ID",
          value: "patient_id",
        },

        { text: "Name", value: "patient.patient_name" },

        { text: "Doctor", value: "doctor.dr_name" },
        // { text: "Invoice", value: "sub_total" },
        { text: "Received", value: "paid_amount" },
        // { text: "Discount", value: "discount_amount" },
        { text: "Pay", value: "payment_method" },
        { text: "User", value: "user.first_name" },

        { text: "Status", value: "status" },
        { text: "Action", value: "actions", sortable: false },
      ],
      desserts: [],

      items: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
        },
        {
          text: "Invoices",
          disabled: true,
          href: "Invoices",
        },
      ],
    };
  },
  // Fetches posts when the component is created.
  created() {
    atshq.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("token");
    this.initialize(this.date);
    this.getDoctors();
  },
  computed: {
    itemsWithSno() {
      return this.desserts.map((d, index) => ({ ...d, sno: index + 1 }));
    },
  },
  methods: {
    initialize(date) {
      atshq
          .get("invoices/invoices?inv_date=" + date)
          .then((response) => {
            // JSON responses are automatically parsed.
            this.loadingstatus = false;
            this.desserts = response.data.data;
          })
          .catch((e) => {
            // this.$noty.error("Oops, something went wrong!");
            this.$noty.error(" " + e);
            // this.errors.push(e);
          });
    },
    getDoctors() {
      atshq
          .get("doctors")
          .then((response) => {
            // JSON responses are automatically parsed.
            this.doctors = response.data.data;
          })
          .catch((e) => {
            this.errors.push(e);
          });
    },

    getColor(status) {
      if (status == "void") return "red";
      else return "green";
    },
    internal_refer(item) {
      // window.open(this.returnUrl + "printdoc/invoice/" + item.invoice_id + "/1");
      this.internal_doctor = item;
      this.dialog = true;
    },
    invoice_print(item) {
      window.open(this.returnUrl + "printdoc/invoice/" + item.invoice_id + "/1");
    },

    invoice_edit(item) {
      this.$router.push("/invoice/edit/" + item.invoice_id);
      // console.warn(item);
    },

    void_request(item) {
      console.log(item);
      this.dialog = true;
    },
    invoice_gen(item) {
      this.$router.push("/invoice-create/" + item.patient_id);
      // console.warn(item);
    },
    dateSelect(date) {
      this.loadingstatus = true;
      this.initialize(date);
    },
    printList() {
      window.open(
          this.returnUrl +
          "printdoc/invoice_list/" +
          this.date +
          "/" +
          localStorage.getItem("userId")
      );
    },
    printListAll() {
      window.open(this.returnUrl + "printdoc/invoice_list/" + this.date);
    },
  },
};
</script>
